import { useContext } from 'react';
import { type RichTextEditorConfig, RichTextEditorContext } from '../context';

export const useRichTextEditorReactSettings = () => useContext<RichTextEditorConfig>(RichTextEditorContext);
